import React, {useEffect, useState} from 'react';
import {t} from "i18next";
import {Modal} from "../components/Modal";
import {ChevronDownIcon} from "@radix-ui/react-icons";
import {Transition} from "@headlessui/react";
import {deleteProfession, updateProfession} from "../service/accountApi";
import Cookies from "universal-cookie";

export const EditProfessionForm = (props) => {
    const {
        showEditProfessionForm,
        setShowEditProfessionForm,
        professionData,
        setProfessionData,
        accountDetails,
        setAccountDetails
    } = props;

    const cookies = new Cookies();
    const locale = cookies.get("locale");

    const [error, setError] = useState({});

    const [isEmploymentTypeDropdownOpen, setIsEmploymentTypeDropdownOpen] = useState(false);
    const [isSelectingEmploymentType, setIsSelectingEmploymentType] = useState(false);

    const [isUpdateProfessionButtonDisabled, setIsUpdateProfessionButtonDisabled] = useState(false);
    const [isDeleteProfessionButtonDisabled, setIsDeleteProfessionButtonDisabled] = useState(false);

    const [professionDetails, setProfessionDetails] = useState({
        _id: '',

        employmentTitle: '',
        businessOrCompanyName: '',

        employmentType: '',
        startDate: '',
        endDate: '',

        isCurrentProfession: false,

        city: '',
        state: '',
        country: '',
    });

    const [showDeleteProfessionConfirmationModal, setShowDeleteProfessionConfirmationModal] = useState(false);

    const [needAssistance, setNeedAssistance] = useState(false);
    const [needAssistanceDescription, setNeedAssistanceDescription] = useState('');

    const employmentTypeLabel = (employmentType) => {
        switch (employmentType) {
            case 'Service':
                return t("PROFESSION_FORM.EMPLOYMENT_TYPE.SERVICE");
            case 'Business':
                return t("PROFESSION_FORM.EMPLOYMENT_TYPE.BUSINESS");
            case 'Retired':
                return t("PROFESSION_FORM.EMPLOYMENT_TYPE.RETIRED");
            default:
                return "";
        }
    }

    const handleEmploymentTypeSelect = (employmentType) => {
        setIsSelectingEmploymentType(false);
        setIsEmploymentTypeDropdownOpen(false);
        setProfessionDetails({
            ...professionDetails,
            employmentType: employmentType
        });

        setError({
            ...error,
            employmentType: ""
        })
    }

    const handleFormData = (e) => {
        console.log(e.target.name + ': ' + e.target.value);

        setProfessionDetails({
            ...professionDetails,
            [e.target.name]: e.target.value
        });

        setError({
            ...error,
            [e.target.name]: ""
        });
    }

    const validate = () => {
        let err = {};

        if (professionDetails.employmentTitle === '') {
            err['employmentTitle'] = t("PROFESSION_FORM.EMPLOYMENT_TITLE.REQUIRED_ERROR");
        }

        if (professionDetails.businessOrCompanyName === '') {
            err['businessOrCompanyName'] = t("PROFESSION_FORM.BUSINESS_OR_COMPANY_NAME.REQUIRED_ERROR");
        }

        if (professionDetails.employmentType === '') {
            err['employmentType'] = t("PROFESSION_FORM.EMPLOYMENT_TYPE.REQUIRED_ERROR");
        }

        if (professionDetails.startDate === '') {
            err['startDate'] = t("PROFESSION_FORM.START_DATE.REQUIRED_ERROR");
        }

        if (!professionDetails.isCurrentProfession) {
            if (professionDetails.endDate === '') {
                err['endDate'] = t("PROFESSION_FORM.END_DATE.REQUIRED_ERROR");
            }
        }

        if (professionDetails.city === '') {
            err['city'] = t("PROFESSION_FORM.CITY.REQUIRED_ERROR");
        }

        if (professionDetails.state === '') {
            err['state'] = t("PROFESSION_FORM.STATE.REQUIRED_ERROR");
        }

        if (professionDetails.country === '') {
            err['country'] = t("PROFESSION_FORM.COUNTRY.REQUIRED_ERROR");
        }

        return err;
    }

    const handleDelete = async () => {
        console.log("Inside Handle Delete!");
        setIsDeleteProfessionButtonDisabled(true);

        console.log("Profession Details: ", professionDetails);
        const professionData = {
            userAccountId: accountDetails._id,
            professionDetails: professionDetails,
        };
        const deleteProfessionDataResponse = await deleteProfession(professionData);

        console.log('(EditProfessionForm) Delete Profession Data Response: ', deleteProfessionDataResponse);

        if (deleteProfessionDataResponse.success) {
            setAccountDetails(deleteProfessionDataResponse.data);
            setShowDeleteProfessionConfirmationModal(false);
            setIsDeleteProfessionButtonDisabled(false);
            setShowEditProfessionForm(false);
            setIsUpdateProfessionButtonDisabled(false);
            setTimeout(() => {
                setProfessionDetails({
                    _id: '',

                    schoolOrCollegeName: '',
                    businessOrCompanyName: '',

                    employmentType: '',
                    startDate: '',
                    endDate: '',

                    isCurrentProfession: false,

                    city: '',
                    state: '',
                    country: '',
                });
                setProfessionData(null);
            }, 200);
        }
    }

    const handleSubmit = async () => {
        console.log("Inside Handle Submit!");
        setIsUpdateProfessionButtonDisabled(true);
        const err = validate();

        if (Object.keys(err).length > 0) {
            setError(err);
            setIsUpdateProfessionButtonDisabled(false);
            return;
        }

        console.log("Profession Details in Edit Profession Form: ", professionDetails);
        const professionData = {
            userAccountId: accountDetails._id,
            professionDetails: professionDetails,
        };
        const updateProfessionDataResponse = await updateProfession(professionData);

        console.log('(EditProfessionForm) Edit Profession Data Response: ', updateProfessionDataResponse);

        if (updateProfessionDataResponse.success) {
            setAccountDetails(updateProfessionDataResponse.data);
            setShowDeleteProfessionConfirmationModal(false);
            setIsDeleteProfessionButtonDisabled(false);
            setShowEditProfessionForm(false);
            setIsUpdateProfessionButtonDisabled(false);
            setTimeout(() => {
                setProfessionDetails({
                    _id: '',

                    schoolOrCollegeName: '',
                    businessOrCompanyName: '',

                    employmentType: '',
                    startDate: '',
                    endDate: '',

                    isCurrentProfession: false,

                    city: '',
                    state: '',
                    country: '',
                });
                setProfessionData(null);
            }, 200);
        }
    }

    useEffect(() => {
        if (professionData) {
            console.log("Profession Data: ", professionData);
            setProfessionDetails({
                _id: professionData._id,

                employmentTitle: professionData.employmentTitle,
                businessOrCompanyName: professionData.businessOrCompanyName,

                employmentType: professionData.employmentType,
                startDate: new Date(professionData.startDate).toISOString().slice(0, 7),
                endDate: professionData.endDate ? new Date(professionData.endDate).toISOString().slice(0, 7) : "",

                isCurrentProfession: professionData.isCurrentProfession,

                city: professionData.city,
                state: professionData.state,
                country: professionData.country,
            });
        }
    }, [professionData]);

    return (
        <>
            {/* Edit Profession */}
            <Modal isOpen={showEditProfessionForm}>
                <div className="form-modal-container">
                    {/* Header */}
                    <div className={"form-modal-header-container"}>
                        {/* Header Title | Close Button */}
                        <div className={"flex flex-row items-center justify-between"}>
                            {/* Form Title */}
                            <h2>
                                {t("PROFESSION_FORM.EDIT_TITLE")}
                            </h2>

                            {/* Close Button */}
                            <button
                                onClick={() => {
                                    setTimeout(() => {
                                        setProfessionDetails({
                                            _id: '',

                                            schoolOrCollegeName: '',
                                            businessOrCompanyName: '',

                                            employmentType: '',
                                            startDate: '',
                                            endDate: '',

                                            isCurrentProfession: false,

                                            city: '',
                                            state: '',
                                            country: '',
                                        });
                                        setProfessionData(null);
                                        setError({});
                                    }, 200);
                                    setShowEditProfessionForm(false);
                                }}
                                type="button"
                                data-drawer-hide="drawer-form"
                                aria-controls="drawer-form"
                            >
                                <img
                                    className={"w-[75%] h-[75%]"}
                                    src={"/assets/close-icon.png"}
                                    alt={"Close"}
                                    title={"Close"}
                                />
                            </button>
                        </div>

                        {/* Divider */}
                        <div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>
                    </div>

                    {/* Form Fields */}
                    <div className={"form-modal-body-container"}>
                        {/* Employment Title */}
                        <fieldset>
                            <div className="custom-input-container">
                                <label htmlFor="employmentTitle">
                                    {t("PROFESSION_FORM.EMPLOYMENT_TITLE.LABEL")}
                                </label>

                                <div className="flex-1 flex flex-col">
                                    <input
                                        id="employmentTitle"
                                        className="custom-input"
                                        name='employmentTitle'
                                        value={professionDetails.employmentTitle}
                                        onChange={handleFormData}
                                    />
                                    {
                                        error['employmentTitle'] &&
                                        <p className="custom-input-error-message" id="error">
                                            {error['employmentTitle']}
                                        </p>
                                    }
                                </div>
                            </div>
                        </fieldset>

                        {/* Business or Company Name */}
                        <fieldset>
                            <div className="custom-input-container">
                                <label htmlFor="businessOrCompanyName">
                                    {t("PROFESSION_FORM.BUSINESS_OR_COMPANY_NAME.LABEL")}
                                </label>

                                <div className="flex-1 flex flex-col">
                                    <input
                                        id="businessOrCompanyName"
                                        className="custom-input"
                                        name='businessOrCompanyName'
                                        value={professionDetails.businessOrCompanyName}
                                        onChange={handleFormData}
                                    />
                                    {
                                        error['businessOrCompanyName'] &&
                                        <p className="custom-input-error-message" id="error">
                                            {error['businessOrCompanyName']}
                                        </p>
                                    }
                                </div>
                            </div>
                        </fieldset>

                        {/* Employment Type | Start Date | End Date */}
                        <fieldset>
                            <div className="custom-input-multiple-fields-container">
                                {/* Employment Type */}
                                <div className="custom-input-container">
                                    <label htmlFor="employmentType">
                                        {t("PROFESSION_FORM.EMPLOYMENT_TYPE.LABEL")}
                                    </label>

                                    <div className="w-full h-full flex flex-col">
                                        <button
                                            onBlur={() => {
                                                if (!isSelectingEmploymentType) {
                                                    setIsEmploymentTypeDropdownOpen(false);
                                                }
                                            }}
                                            className="custom-input-dropdown-button"
                                            onClick={() => setIsEmploymentTypeDropdownOpen(!isEmploymentTypeDropdownOpen)}
                                        >
                                            <p className={""}>
                                                {employmentTypeLabel(professionDetails.employmentType)}
                                            </p>

                                            <ChevronDownIcon
                                                className={`${isEmploymentTypeDropdownOpen ? 'rotate-180' : 'rotate-0'} `}
                                                aria-hidden="true"
                                                stroke="#292D32"
                                                strokeWidth={"0.1vh"}
                                            />
                                        </button>

                                        {/* Employment Type Dropdown */}
                                        <div className={"relative"}>
                                            <Transition show={isEmploymentTypeDropdownOpen}>
                                                <div
                                                    className={`bg-white absolute left-0 right-0 z-[100] max-h-[15vh]
                                                        origin-top-right rounded-md shadow-2xl 
                                                        border border-gray-700 overflow-y-scroll
                                                        data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 
                                                        data-[enter]:duration-100 data-[enter]:ease-out 
                                                        data-[leave]:duration-75 data-[leave]:ease-in`}
                                                >
                                                    <button
                                                        className="custom-input-dropdown-list-button"
                                                        onMouseDown={() => setIsSelectingEmploymentType(true)}
                                                        onClick={() => handleEmploymentTypeSelect("Service")}
                                                    >
                                                        <p>
                                                            {t("PROFESSION_FORM.EMPLOYMENT_TYPE.SERVICE")}
                                                        </p>
                                                    </button>
                                                    <button
                                                        className="custom-input-dropdown-list-button"
                                                        onMouseDown={() => setIsSelectingEmploymentType(true)}
                                                        onClick={() => handleEmploymentTypeSelect("Business")}
                                                    >
                                                        <p>
                                                            {t("PROFESSION_FORM.EMPLOYMENT_TYPE.BUSINESS")}
                                                        </p>
                                                    </button>
                                                    <button
                                                        className="custom-input-dropdown-list-button"
                                                        onMouseDown={() => setIsSelectingEmploymentType(true)}
                                                        onClick={() => handleEmploymentTypeSelect("Retired")}
                                                    >
                                                        <p>
                                                            {t("PROFESSION_FORM.EMPLOYMENT_TYPE.RETIRED")}
                                                        </p>
                                                    </button>
                                                </div>
                                            </Transition>
                                        </div>

                                        {
                                            error['employmentType'] &&
                                            <p className="custom-input-error-message" id="error">
                                                {error['employmentType']}
                                            </p>
                                        }
                                    </div>
                                </div>

                                {/* Start Date */}
                                <div className="custom-input-container">
                                    <label htmlFor='startDate'>
                                        {t("PROFESSION_FORM.START_DATE.LABEL")}
                                    </label>
                                    <div className="relative w-full">
                                        <input
                                            type={"month"}
                                            name='startDate'
                                            required
                                            value={professionDetails.startDate}
                                            onChange={handleFormData}
                                            className={`custom-input`}
                                        />
                                        {
                                            error['startDate'] &&
                                            <p className="custom-input-error-message" id="error">
                                                {error['startDate']}
                                            </p>
                                        }
                                    </div>
                                </div>

                                {/* End Date */}
                                <div className="custom-input-container">
                                    <label
                                        className=''
                                        htmlFor='endDate'
                                    >
                                        {t("PROFESSION_FORM.END_DATE.LABEL")}
                                    </label>
                                    <div className="relative w-full">
                                        <input
                                            disabled={professionDetails.isCurrentProfession}
                                            type={"month"}
                                            name='endDate'
                                            value={professionDetails.endDate}
                                            onChange={handleFormData}
                                            className="custom-input"
                                        />
                                        {
                                            error['endDate'] &&
                                            <p className="custom-input-error-message" id="error">
                                                {error['endDate']}
                                            </p>
                                        }
                                    </div>
                                </div>
                            </div>
                        </fieldset>

                        {/* Current Profession CheckBox */}
                        <fieldset>
                            <label className="custom-input-label-checkbox">
                                <input
                                    type="checkbox"
                                    name='isCurrentProfession'
                                    checked={professionDetails.isCurrentProfession}
                                    onChange={(e) => {
                                        console.log("Is Current Profession: ", e.target.checked);
                                        setProfessionDetails({
                                            ...professionDetails,
                                            isCurrentProfession: e.target.checked,
                                            endDate: ""
                                        });
                                    }}
                                />
                                <p>
                                    {t("PROFESSION_FORM.PRESENT")}
                                </p>
                            </label>
                        </fieldset>

                        {/* City | State | Country */}
                        <fieldset>
                            <div className="custom-input-multiple-fields-container flex-wrap">
                                {/* City */}
                                <div className="custom-input-container">
                                    <label htmlFor="city">
                                        {t("PROFESSION_FORM.CITY.LABEL")}
                                    </label>

                                    <div className="flex-1 flex flex-col">
                                        <input
                                            id="city"
                                            className="custom-input"
                                            name='city'
                                            value={professionDetails.city}
                                            onChange={handleFormData}
                                        />
                                        {
                                            error['city'] &&
                                            <p className="custom-input-error-message" id="error">
                                                {error['city']}
                                            </p>
                                        }
                                    </div>
                                </div>

                                {/* State */}
                                <div className="custom-input-container">
                                    <label htmlFor="state">
                                        {t("PROFESSION_FORM.STATE.LABEL")}
                                    </label>

                                    <div className="flex-1 flex flex-col">
                                        <input
                                            id="state"
                                            className="custom-input"
                                            name='state'
                                            value={professionDetails.state}
                                            onChange={handleFormData}
                                        />
                                        {
                                            error['state'] &&
                                            <p className="custom-input-error-message" id="error">
                                                {error['state']}
                                            </p>
                                        }
                                    </div>
                                </div>

                                {/* Country */}
                                <div className="custom-input-container">
                                    <label htmlFor="country">
                                        {t("PROFESSION_FORM.COUNTRY.LABEL")}
                                    </label>

                                    <div className="flex-1 flex flex-col">
                                        <input
                                            id="country"
                                            className="custom-input"
                                            name='country'
                                            value={professionDetails.country}
                                            onChange={handleFormData}
                                        />
                                        {
                                            error['country'] &&
                                            <p className="custom-input-error-message" id="error">
                                                {error['country']}
                                            </p>
                                        }
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </div>

                    {/* Footer */}
                    <div className={"form-modal-footer-container"}>
                        {/* Divider */}
                        <div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>

                        {/* Delete Button | Submit Button */}
                        <div className="flex items-center justify-between">
                            {/* Delete Button */}
                            <button
                                disabled={isDeleteProfessionButtonDisabled || isUpdateProfessionButtonDisabled}
                                onClick={() => setShowDeleteProfessionConfirmationModal(true)}
                                className="form-modal-footer-container-delete-button"
                            >
                                <img
                                    src="/assets/delete-icon-filled-light.png"
                                    alt="Delete"
                                />
                                <p>
                                    {t("PROFESSION_FORM.DELETE")}
                                </p>
                            </button>

                            {/* Submit Button */}
                            <button
                                disabled={isUpdateProfessionButtonDisabled || isDeleteProfessionButtonDisabled}
                                onClick={handleSubmit}
                                className="form-modal-footer-container-submit-button"
                            >
                                <p>
                                    {t("PROFESSION_FORM.EDIT_SUBMIT")}
                                </p>
                                <svg
                                    viewBox="0 0 6 6"
                                    fill="none"
                                    id={"arrow-icon"}
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M3 1L5 3L3 5"
                                        id={"arrow-icon-tip"}
                                        stroke="black"
                                        strokeLinecap="square"
                                    />
                                    <path
                                        d="M1 3L4 3"
                                        id={"arrow-icon-line"}
                                        stroke="black"
                                        strokeLinecap="square"
                                    />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>

            {/* Delete Profession */}
            <Modal isOpen={showDeleteProfessionConfirmationModal}>
                <div className="delete-modal-container">
                    {/* Header */}
                    <div className={"delete-modal-header-container"}>
                        {/* Header Title | Close Button */}
                        <div className={"flex flex-row items-center justify-between"}>
                            {/* Form Title */}
                            <h2>
                                {t("PROFESSION_FORM.DELETE_MODAL.TITLE")}
                            </h2>

                            {/* Close Button */}
                            <button
                                onClick={() => setShowDeleteProfessionConfirmationModal(false)}
                            >
                                <img
                                    className={"w-[75%] h-[75%]"}
                                    src={"/assets/close-icon.png"}
                                    alt={"Close"}
                                    title={"Close"}
                                />
                            </button>
                        </div>

                        {/* Divider */}
                        <div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>
                    </div>

                    {/* Content */}
                    <div className={"delete-modal-body-container"}>
                        <p>
                            {
                                locale === "mr"
                                    ?
                                    <>
                                        {t("PROFESSION_FORM.DELETE_MODAL.DESCRIPTION_P1", {
                                            pronoun: window.location.pathname.includes("personal-profile") ? "आपले" : "त्यांचे"
                                        })}
                                        <span className={"!font-custom-semi-bold underline"}>
                                            {professionDetails.businessOrCompanyName}
                                        </span>
                                        {t("PROFESSION_FORM.DELETE_MODAL.DESCRIPTION_P2")}
                                    </>
                                    :
                                    <>
                                        {t("PROFESSION_FORM.DELETE_MODAL.DESCRIPTION", {
                                            pronoun: window.location.pathname.includes("personal-profile") ? "your" : "their"
                                        })}
                                        <span className={"!font-custom-semi-bold underline"}>
                                            {professionDetails.businessOrCompanyName}
                                        </span>
                                        ?
                                    </>
                            }
                        </p>
                    </div>

                    {/* Footer */}
                    <div className={"delete-modal-footer-container"}>
                        {/* Divider */}
                        <div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>

                        {/* Cancel | Delete */}
                        <div className="flex flex-row items-center justify-between">
                            {/* Cancel Button */}
                            <button
                                disabled={isDeleteProfessionButtonDisabled}
                                onClick={() => setShowDeleteProfessionConfirmationModal(false)}
                                className="delete-modal-footer-container-cancel-button"
                            >
                                <p>
                                    {t("PROFESSION_FORM.DELETE_MODAL.CANCEL")}
                                </p>
                                <svg
                                    viewBox="0 0 6 6"
                                    fill="none"
                                    id={"arrow-icon"}
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M3 1L5 3L3 5"
                                        id={"arrow-icon-tip"}
                                        stroke="black"
                                        strokeLinecap="square"
                                    />
                                    <path
                                        d="M1 3L4 3"
                                        id={"arrow-icon-line"}
                                        stroke="black"
                                        strokeLinecap="square"
                                    />
                                </svg>
                            </button>

                            {/* Delete Button */}
                            <button
                                disabled={isDeleteProfessionButtonDisabled}
                                onClick={handleDelete}
                                className="delete-modal-footer-container-delete-button"
                            >
                                <img
                                    src="/assets/delete-icon-filled-light.png"
                                    alt="Delete"
                                />
                                <p>
                                    {t("PROFESSION_FORM.DELETE_MODAL.DELETE")}
                                </p>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
}
